import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Table, Params } from 'nallian-table-builder-ui';
import apiRoutes from '../../../../app/api/routes';
import { TABS } from '../../../organisations/constants';
import Country from '../../../app/components/Country';
import ActiveState from '../../../organisations/components/ActiveState';
import { INFINITE_SCROLL } from '../../constants';

const AppInstallationOrganisations = () => {
  const { t } = useTranslation();
  const { id: appId, installationId } = useParams();

  if (!appId || !installationId) {
    return null;
  }

  return (
    <Table
      resource={`appInstallationOrganisations_${appId}_${installationId}`}
      url={apiRoutes.appInstallationOrganisations(appId, installationId)}
      noResultsMessage={t('noOrganisationsFound')}
      infiniteScroll={INFINITE_SCROLL}
      pageSize={50}
      filtered
      sorted
      resizable
    >
      <Params.String
        name="organisationName"
        label={t('organisationName')}
        link={`/organisations/:id/${TABS.DETAILS}`}
        width="25rem"
        grow
      />
      <Params.String name="city" label={t('city')} width="15rem" noSort noFilter />
      <Params.Custom
        name="countryCode"
        label="country"
        sortName="countryCode"
        content={Country}
        width="8rem"
        minWidth="8rem"
        noFilter
        noSort
        grow
      />
      <Params.Custom
        content={ActiveState}
        name="activeStateId"
        label="activeState"
        width="8rem"
        minWidth="8rem"
        noSort
        noFilter
        grow
      />
    </Table>
  );
};

export default AppInstallationOrganisations;
